import type { ChallengeData } from "./api"

import { loadProgress as loadBallSortProgress } from "../sortaballs-8-colors/puzzle-progress"
import { loadProgress as loadSortaballsProgress } from "../sortaballs-10-colors/puzzle-progress"

// Both games write a puzzle-progress entry only on solve, so a changed
// timestamp for `challenge.index` since the battle started means the player
// just completed the puzzle. Shared by the accept and create battle flows.
//
// TODO(bug-solved): the lookup below can never match. `loadProgress()` is keyed
// by `boardId` (the content hash of the initial board) and drops numeric-keyed
// entries (see shared-sortaballs/puzzle-progress.ts), while `challenge.index`
// is the numeric puzzle level. Resolve the board first —
// `getPuzzleById(challenge.index)?.boardId` from sortaballs-10-colors/puzzles
// (hard mode) or sortaballs-8-colors/puzzle-loader — then `.get(boardId)`.
// Mind the lazy 10-colors chunk at battle start: an undefined board there also
// loses the pre-battle timestamp snapshot. The unit specs
// (use-battle.spec.ts / use-create-battle.spec.tsx) still seed
// `{ puzzleId: index }`, which the store now discards — update them too.
export const getSolvedTimestamp = (challenge: ChallengeData): string | undefined=>
  (challenge.hard_mode
    ? loadSortaballsProgress()
    : loadBallSortProgress()
  ).get(String(challenge.index))?.timestamp